import React from 'react';
import { observer } from 'mobx-react-lite';

import styled from '@emotion/styled';

import ExpandableView from './ExpandableView';

import Branding from './Branding';
import DriverDetails from './DriverDetails';
import Map2 from './Map2';
import { AutoSizer } from 'react-virtualized';

import RACTitle from './Title';
import RACAAACTitle from './AAACTitle';
import RACContact from './Contact';

import { racJob, racAaacJob } from './helpers';

import useStylesheets from '@vromo/hooks/useStylesheets';

import { useStore } from '@vromo/mobx-react/mobx-react';
import TrackingLinkStore from '../TrackingLinkStore';

import SpatulaSignedJobView from './SpatulaSignedJobView.css';

const Container = styled.div`
    flex: 1;
    font-family: Helvetica, Open Sans, sans-serif;
    background: ${({ theme }) => theme.background};
    overflow: hidden;
`;

const DetailsContainer = styled.div`
    display: flex;
    background: ${({ theme }) => theme.background};
    flex-direction: column;
    padding: 12px;
    align-items: center;
    flex-shrink: 0;
`;

const SpatulaButton = styled.a`
    background-color: ${({ theme }) => theme.background};
    display: block;
    padding-bottom: 6px;
    padding-left: 6px;
    font-family: Helvetica, Open Sans, sans-serif;
    font-size: 12px;
    color: rgb(181, 181, 181);
    cursor: pointer;
    text-decoration: none;
`;

/** cusotom componet for 'Royal Automobile Club of Western Australia' */
export default observer<{ host: string, auth: string }>(function RAC({ host, auth }) {

    useStylesheets(SpatulaSignedJobView);
    const rootStore = useStore<TrackingLinkStore>('rootStore');
    // this component is only loaded by parent when there is at least 1 job
    const job = rootStore.jobs.first()!;

    return (
        <Container>
            <div
                style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                <Branding />
                {racAaacJob(job) && <RACAAACTitle />}
                {racJob(job) && <RACTitle />}

                <div style={{ flex: 1 }}>
                    <AutoSizer>
                        {({ width, height }) =>
                            width && height ? (
                                <Map2
                                    jobs={rootStore.jobs}
                                    vehicles={rootStore.vehicles}
                                    width={width}
                                    height={height}
                                />
                            ) : null
                        }
                    </AutoSizer>
                </div>

                <ExpandableView
                    container={({ children, className, expanded }) => (
                        <DetailsContainer>{children}</DetailsContainer>
                    )}
                    expandedContent={<RACContact aaac={racAaacJob(job)} />}
                    collapsedContent={<DriverDetails host={host} auth={auth} />}
                />

                <SpatulaButton target="_blank" href="https://vromo.io/">
                    Powered by Vromo
                </SpatulaButton>
            </div>
        </Container>
    );
});
